export enum ToasterIdEnum {
  SYSTEM = "system",
  FORM = "form",
}
